export default __webpack_public_path__ + "static/media/PlatenKnife.d02d040f.png";